/* Blank price corrections, checked against S&S, SanMar and AS Colour on Oct 12 2026 (S&S sale price; SanMar sale price;
   BELLA + CANVAS at the higher of S&S and SanMar). P: one entry per style id: [blank S-XL, 2XL upcharge, 3XL upcharge,
   {color: its own S-XL price}, [colors taken off: discontinued]]. A listed style gets exactly these colour prices; colours
   not named go back to the blank. CU: colours whose own 2XL/3XL upcharge differs from the style's ({color: [2XL, 3XL]},
   null = the style's own); every price on the site then follows the colour picked: the product panel, the size boxes,
   the request lines, drawer, request page, emailed breakdown, PDF and copied text.
   Applied as the styles are pushed into window.STYLES, ahead of fab.js and rva-cat.js, the same way rva-cat-flat.js and
   rva-cat-fab.js patch the data, so the eight data files stay as they are. The colour upcharges are wired in once
   rva-cat.js and its add-ons have loaded: upOf() takes the colour, and the request functions pass their line's colour.
   repriceReq is already wrapped by rva-cat-yv.js by then, so its 2XL/3XL cells are set again from the line's colour after it runs.
   Loaded first by sections/rva-as.liquid on the catalog-type pages and added to window.RVA_CAT_DATA everywhere else. */
(function(){if(window.__rvaPxOn)return;window.__rvaPxOn=1;var P={
24:[5.49,1.87,3.12],
29:[4.03,1.75,3.03],
39:[2.67,1.57,2.82,{"Natural":2.43,"PFD White":2.74,"White":2.43}],
123:[6.99,2.59,4.37],
130:[5.65,1.61,4.06,{"White":4.43}],
135:[5.19,1.73,4.31,{"Natural":4.08,"White":4.08}],
160:[6.26,3.25,5.22,{"White":4.37}],
184:[9.05,1.21,2.93,{"Natural":8.03,"White":8.03}],
372:[6.41,2.27,3.85,{"White":5.55}],
395:[8.97,2.63,4.89],
415:[13.35,6.07,9.12,{"White":12.21}],
1441:[6.29,1.19,2.36,{"Charcoal Black Triblend":6.16}],
1616:[17.06,1.22,1.22,{"Forest Camo":18.18,"Rust":17.95}],
1756:[20.97,5.43,5.43],
1760:[25.79,3.7,3.7],
1761:[34.19,4,4],
1787:[11.4,2.2,null,{"Charcoal Black Triblend":10.38,"Grey Triblend":10.59,"Heather Navy":10.79,"Heather True Royal":10.79}],
1822:[5.33,1.16,2.43],
1941:[6.6,1.61,2.87,{"White":4.95}],
2003:[14.99,1.78,3.54,{"Grey Triblend":15.99}],
2212:[7.19,1.19,null,{"Charcoal Black Triblend":6.89}],
2213:[5.19,1.99,null,{"Asphalt Slub":6.39,"White Marble":6.89}],
2387:[17.75,1.69,1.69,{"Gunmetal Heather/ Burgundy Heather":15.68}],
2566:[3.99,0.36,0.71,{},["Vintage Heather/ Vintage Burgundy","Vintage Heather/ Vintage Royal"]],
2764:[7.48,1.27,null,{"Grey/ Maroon Triblend":6.99,"Grey/ Red Triblend":6.99,"Grey/ True Royal Triblend":6.99},["Grey/ Charcoal Black Triblend"]],
3214:[3.65,1.53,2.77],
3221:[4.6,2.02,3.69],
3227:[3.7,1.37,2.67],
3444:[12.82,3.05,5.45],
3868:[6.65,0.85,2.62,{"White":6.63}],
6174:[15.99,1.78,null],
6364:[3.65,1.42,1.71],
7584:[4.09,1.68,3],
9352:[11.66,3.34,6.07,{"Heather Black":12.04}],
9460:[4.79,0.8,2.38,{"White":3.61}],
10669:[8.52,3.01,3.02],
10672:[5.68,1.17,1.87,{"White":5.48}],
10680:[3.59,2.53,3.17,{"White":3.47}],
10722:[3.34,2.4,3.4,{"White":2.99},["Ash","Cantaloupe","Cardinal","Cassis","Heather Burgundy","Heather Red","Heather Royal","Inked India","Light Mint","Silver"]],
11748:[5.9,1.5,2.5,{},["Washed Natural"]],
11977:[14.95,3.07,3.07],
13530:[9.85,0.75,1.14,{"Sage Camo":12.2,"Slate Camo":12.2}],
13538:[9.49,0.5,1,{"Black":8.82,"Forest Green":8.82,"Navy":8.82,"PFD":8.82,"Sandshell":8.82}],
900739:[5.65,1.79,3.96,{"Natural":4.43,"White":4.43}],
901626:[2.89,2.03,3.57,{"White":2.59}],
901634:[3.02,1.94,2.69,{"Natural":2.67,"White":2.67}],
903985:[2.44,2.08,3.37,{"Natural":2.33,"White":2.33}],
904664:[4.94,1.78,2.78,{},["Gold Fish","Guacamole","Jadeite","Merlot","Neon Orange"]],
905708:[2.99,1.91,2.81,{"White":2.89}],
906337:[3.04,2.06,3.06,{},["Rose Fleck"]],
907449:[2.89,1.69,3.08,{"Ivory":2.79,"White":2.79}],
907839:[8.06,1.7,2.7,{},["Jadeite","Merlot"]],
910047:[5.8,1.14,2.22,{},["Black/Red","Black/Teal"]],
910641:[9.55,2.65,4.47],
911121:[15.51,1,3,{},["Black/Red","Black/Teal"]],
957774:[5.24,0,2,{"Dark Heather Grey":5.73,"Eco Heather":5.73,"Heather Grey":5.73}],
957777:[6.07,0,2,{"Cool Heather Grey":6.65,"Dark Heather Grey":6.65,"Eco Heather":6.65,"Heather Grey":6.65,"Mid Heather Grey":6.65}],
957783:[15.38,0,2.38,{"Dark Heather Grey":16.84,"Heather Grey":16.84}],
957787:[26.82,0,4.15,{"Cool Heather Grey":29.38,"Dark Heather Grey":29.38,"Eco Heather":29.38,"Heather Grey":29.38,"Mid Heather Grey":29.38}],
957789:[29.6,0,3.88,{"Cool Heather Grey":32.42,"Dark Heather Grey":32.42,"Heather Grey":32.42}],
970001:[5.19,2.06,0],
970002:[6.29,1.19,0,{"Black Marble":6.91}],
970003:[3.99,1.86,0],
970004:[3.99,1.86,0],
970005:[4.99,1.99,2.86],
970006:[15.99,1.78,0],
970014:[3.56,1.89,3.16,{"White":3.05}],
970015:[16.33,2.72,0,{"Black Camo":17.3,"Tie Dye Cotton Candy":20.17}],
975205:[22.2,0,3,{"Heather Grey":24.31}],
980006:[11.34,0,0,{},["Cardinal Red"]],
981674:[9.71,0,2,{"Eco Heather":10.63,"Heather Grey":10.63}]
};
var CU={
10:{"White":[1.43,2.09]},
16:{"Natural":[1.37,2.37],"White":[1.37,2.37]},
28:{"White":[1.19,2.56]},
29:{"Olive":[0.97,2.17],"Royal Purple":[null,2.17],"Sand Dune":[0.97,null],"Vintage Denim":[0.97,null],"Vintage Navy":[null,2.17]},
32:{"Natural":[1.49,2.67],"White":[1.49,2.67]},
39:{"Natural":[1.36,2.66],"PFD White":[1.98,3.81],"White":[1.36,2.66]},
90:{"White":[1.01,2.62]},
94:{"White":[1.05,2.76]},
117:{"White":[1.9,3.47]},
130:{"White":[1.7,3.26]},
135:{"Natural":[1.94,3.87],"White":[1.94,3.87]},
143:{"White":[1.08,2.43]},
146:{"White":[1.39,2.7]},
155:{"White":[1.22,2.95]},
160:{"White":[3.01,4.75]},
173:{"Black":[1.99,3.29],"Navy":[1.99,3.29],"Red":[1.99,3.29]},
184:{"Natural":[1.89,3.54],"White":[1.89,3.54]},
360:{"Forest Camo":[1.14,1.14]},
372:{"White":[1.54,3]},
403:{"Army Camo":[3.8,3.8],"Black Camo":[3.8,3.8],"Darkwood Tree Camo":[3.8,3.8],"Deadwood Tree Camo":[3.8,3.8],"Duck Camo":[3.8,3.8],"Forest Camo":[3.8,3.8],"Houndstooth":[4.05,4.05],"Realtree APX Camo":[1,1],"Snow Camo":[3.8,3.8],"Tiger Camo":[3.8,3.8]},
415:{"White":[6,9.22]},
1441:{"Charcoal Black Triblend":[1.17,2.32]},
1616:{"Forest Camo":[1.79,1.79],"Rust":[1.4,1.4]},
1787:{"Charcoal Black Triblend":[1.74,null],"Grey Triblend":[1.78,null],"Heather Navy":[1.78,null],"Heather True Royal":[1.78,null]},
1828:{"Black Camo":[1.49,1.49],"Deadwood Tree Camo":[1.49,1.49],"Duck Camo":[1.49,1.49],"Forest Camo":[1.49,1.49]},
1829:{"Forest Camo":[1.71,1.71]},
1941:{"White":[1.09,2.96]},
2003:{"Grey Triblend":[1.77,null]},
2116:{"White":[2.1,2.61]},
2213:{"Asphalt Slub":[1.89,null],"White Marble":[2.19,null]},
2387:{"Gunmetal Heather/ Burgundy Heather":[1.79,null]},
2564:{"Brown Leopard":[1.5,3.1],"Haze Tie Dye":[1.5,3.1],"Island Tie Dye":[1.5,3.1],"Natural Camo":[1.5,3.1],"Natural Leopard":[1.5,3.1],"Sky Tie Dye":[1.5,3.1],"Storm Camo":[1.5,3.1],"Vintage Camo":[1.5,3.1]},
2764:{"Grey/ Maroon Triblend":[1.78,null],"Grey/ Red Triblend":[1.78,null],"Grey/ True Royal Triblend":[1.78,null]},
2768:{"DTG White":[null,3.15]},
2771:{"Black Camo":[1.71,1.71],"Deadwood Tree Camo":[1.71,1.71],"Forest Camo":[1.71,1.71]},
3303:{"Maroon":[1.57,1.57]},
3304:{"Nickel Heather/ Forest Camo":[1.15,1.15]},
3800:{"Maroon":[2.23,2.23]},
3868:{"Red":[null,0.15],"White":[0.88,2.64]},
4467:{"White":[1.44,1.91]},
6015:{"Prepared For Dye":[1.5,1.05]},
6717:{"Prepared For Dye":[0.85,0.85]},
7584:{"Heather Emerald":[1.26,null],"Heather Lapis":[null,2.51],"Heather Prism Sunset":[1.26,2.51]},
8168:{"White":[2.08,4.45]},
8169:{"White":[1.66,3.63]},
9352:{"Heather Black":[3.79,6.64]},
9440:{"White":[1.43,2.02]},
9460:{"White":[1.21,2.31]},
10667:{"White":[1.19,2.56]},
10669:{"White":[2.72,null]},
10672:{"White":[1.03,1.98]},
10680:{"White":[2.65,3.29]},
10705:{"Black/ Heather Charcoal":[2.61,3.15],"Black/ Red":[2.61,3.15],"Black/ White":[2.61,3.15],"Heather Black/ Black":[2.61,3.15],"Heather Denim/ Navy":[2.61,3.15],"Heather Grey/ Black":[2.61,3.15],"Heather Grey/ Heather Charcoal":[2.61,3.15],"Heather Grey/ Heather Maroon":[2.61,3.15],"Heather Grey/ Navy":[2.61,3.15],"White/ Heather Seafoam":[2.61,3.15]},
10706:{"White":[2.13,2.54]},
10722:{"Neo Mint":[0.51,0.76],"White":[2.42,2.72]},
10928:{"Flag":[2.12,2.9]},
11748:{"Washed Banana Cream":[0.4,null],"Washed Cardinal":[null,1],"Washed Purple Rush":[0.4,1]},
11979:{"Pigment Black":[2.89,2.89]},
12346:{"White":[0.77,1.64]},
13530:{"Sage Camo":[1.79,2.45],"Slate Camo":[1.79,2.45]},
13538:{"Black":[0.71,1.06],"Forest Green":[0.71,1.06],"Navy":[0.71,1.06],"PFD":[0.71,1.06],"Sandshell":[0.71,1.06]},
16990:{"White":[0.9,1.98]},
900739:{"Natural":[1.8,3.52],"White":[1.8,3.52]},
901626:{"White":[1.75,2.86]},
901634:{"Natural":[1.38,1.79],"White":[1.38,1.79]},
903985:{"Natural":[1.88,2.79],"White":[1.88,2.79]},
905708:{"White":[1.81,2.91]},
907449:{"Ivory":[1.71,2.99],"White":[1.71,2.99]},
957783:{"Dark Heather Grey":[null,2.61],"Heather Grey":[null,2.61]},
957787:{"Cool Heather Grey":[null,4.54],"Dark Heather Grey":[null,4.54],"Eco Heather":[null,4.54],"Heather Grey":[null,4.54],"Mid Heather Grey":[null,4.54]},
957789:{"Cool Heather Grey":[null,4.24],"Dark Heather Grey":[null,4.24],"Heather Grey":[null,4.24]},
970002:{"Black Marble":[1.5,null]},
970004:{"Athletic Heather":[1.58,null],"Dark Grey Heather":[1.58,null],"Heather Mauve":[1.58,null]},
970013:{"White":[1.81,2.59]},
970014:{"White":[2.03,2.89]},
970015:{"Black Camo":[2.99,null],"Tie Dye Cotton Candy":[2.59,null]}
};
function fix(st){if(!st||st.__rvaPx)return;var has=P.hasOwnProperty(st.sid),cu=CU.hasOwnProperty(st.sid)?CU[st.sid]:null;if(!has&&!cu)return;st.__rvaPx=1;if(has){var p=P[st.sid],ov=p[3]||{},dr=p[4]||[],up=st.up||[];st.blank=p[0];st.up=[p[1]!=null?p[1]:up[0],p[2]!=null?p[2]:up[1]];if(dr.length&&st.c)st.c=st.c.filter(function(c){return dr.indexOf(c[0])<0});(st.c||[]).forEach(function(c){ov.hasOwnProperty(c[0])?c[4]=ov[c[0]]:c.length>4&&(c[4]=null)})}cu&&(st.cu=cu)}
var S=window.STYLES=window.STYLES||[];S.forEach(fix);if(!S.__rvaPxPush){var push=S.push;S.push=function(){for(var i=0;i<arguments.length;i++)fix(arguments[i]);return push.apply(this,arguments)};S.__rvaPxPush=1}
function cuOf(e,c){var m=e&&e.cu;return m&&c&&m.hasOwnProperty(c[0])?m[c[0]]:null}
function upZ(e,z,c){if(!e||z!=="2XL"&&z!=="3XL")return 0;if(!c&&typeof window.swatchOf=="function")try{c=window.swatchOf(e)}catch(x){}var i=z==="2XL"?0:1,u=cuOf(e,c),v=u&&u[i]!=null?u[i]:e.up&&e.up[i];return+v||0}
function upOf(e,t,c){return upZ(e,(window.SIZES||[])[t],c)}
upOf.rvaCu=1;window.rvaUpZ=upZ;
function swap(name,subs){var f=window[name];if(typeof f!="function")return!1;if(f.rvaCu)return!0;var s=Function.prototype.toString.call(f),i;for(i=0;i<subs.length;i++){if(!subs[i][0].test(s)){try{console.warn("rva-cat-px: "+name+" left as is")}catch(x){}return!1}s=s.replace(subs[i][0],subs[i][1])}var g;try{g=(0,eval)('"use strict";('+s+")")}catch(x){return!1}if(typeof g!="function")return!1;for(i in f)f.hasOwnProperty(i)&&(g[i]=f[i]);g.rvaCu=1;window[name]=g;return!0}
function foot(a,t,n){var base=window.lineBase(a,t.color,n),parts=[],money=window.money;["XS","S","M","L","XL"].some(function(z){return t.sizes[z]})&&parts.push((a.y?a.sizes:"S–XL")+" "+money(base)+" ea");t.sizes["2XL"]&&parts.push("2XL "+money(base+upZ(a,"2XL",t.color))+" ea");t.sizes["3XL"]&&parts.push("3XL "+money(base+upZ(a,"3XL",t.color))+" ea");return parts.join(" \xB7 ")}
foot.rvaCu=1;
function fixTbl(){try{var S=window.S,P=document.getElementById("panel");if(!S||!P||!S.open||typeof window.styleById!="function")return;var e=window.styleById(S.open);if(!e||!e.cu)return;var c=window.swatchOf(e);if(!cuOf(e,c))return;var T=window.TIERS||[],fl=e.t==="fleece",m=window.money;Array.prototype.forEach.call(P.querySelectorAll("table"),function(tb){var th=tb.querySelectorAll("thead th");if(th.length!==4||String(th[2].textContent).indexOf("2X")!==0)return;var rows=tb.querySelectorAll("tbody tr");rows.length===T.length&&Array.prototype.forEach.call(rows,function(r,i){var base=window.costOf(e,c)+(fl&&window.FLEECE_GARMENT||0)+window.printCost(T[i],S.front,S.back,fl);if(!r.cells[3]||r.cells[1].textContent!==m(base))return;e.sz.indexOf("2XL")>=0&&(r.cells[2].textContent=m(base+upZ(e,"2XL",c)));e.sz.indexOf("3XL")>=0&&(r.cells[3].textContent=m(base+upZ(e,"3XL",c)))})})}catch(x){}}
function fixReq(){try{var S=window.S;if(!S||!S.req)return;var e=window.reqPieces(),m=window.money;S.req.forEach(function(t,n){var a=window.styleById(t.id);if(!a||!a.cu)return;var r=window.lineBase(a,t.color,e);["2XL","3XL"].forEach(function(z){var i=document.getElementById("rp"+n+z),o=document.getElementById("rt"+n+z);if(i&&o){var s=r+upZ(a,z,t.color);i.textContent=m(s);o.textContent=m((t.sizes[z]||0)*s)}})})}catch(x){}}
var done=0;
function install(){if(typeof window.lineTotal!="function"||typeof window.swatchOf!="function"||!window.S)return;var first=!done;done=1;window.upOf!==upOf&&(window.upOf=upOf);typeof window.lineFootPrice=="function"&&window.lineFootPrice!==foot&&(window.lineFootPrice=foot);
swap("lineTotal",[[/^function lineTotal\(e,t,n,a\)\{/,"function lineTotal(e,t,n,a){var __c=t;"],[/upOf\(e,a\)/g,"upOf(e,a,__c)"]]);
swap("descLine",[[/upOf\(t,i\)/g,"upOf(t,i,e.color)"]]);
swap("sizeGroups",[[/upOf\(e,i\)/g,"upOf(e,i,t.color)"]]);
swap("rowsHTML",[[/^function rowsHTML\(e,t,n\)\{/,"function rowsHTML(e,t,n){var __l=e;"],[/upOf\(a,SIZES\.indexOf\((n|e)\)\)/g,"upOf(a,SIZES.indexOf($1),__l.color)"]]);
var rq=window.repriceReq;if(typeof rq=="function"&&!rq.rvaCu&&!rq.rvaCuR){if(/upOf\(a,SIZES\.indexOf\(e\)\)/.test(Function.prototype.toString.call(rq)))swap("repriceReq",[[/upOf\(a,SIZES\.indexOf\(e\)\)/g,"upOf(a,SIZES.indexOf(e),t.color)"]]);else{var w=function(){var o=rq.apply(this,arguments);fixReq();return o};for(var k in rq)rq.hasOwnProperty(k)&&(w[k]=rq[k]);w.rvaCuR=1;window.repriceReq=w}}
var f=window.drawPanel;if(typeof f=="function"&&!f.rvaCuP){var g=function(){var o=f.apply(this,arguments);fixTbl();return o};g.rvaCuP=1;g.rvaTbl=1;window.drawPanel=g}
if(first){try{typeof window.render=="function"&&window.render()}catch(x){}try{var sh=document.getElementById("sheet");sh&&!sh.hidden&&window.S.open&&window.drawPanel()}catch(x){}try{var d=document.getElementById("drawer");d&&!d.hidden&&typeof window.drawDrawer=="function"&&window.drawDrawer()}catch(x){}}}
function later(){setTimeout(install,0);setTimeout(install,1500)}
install();document.addEventListener("DOMContentLoaded",later);window.addEventListener("load",later);
})();
